import * as React from 'react';
import './styles.css';
import BasicDialog from '../../../Dialog/components/BasicDialog';

const DiscountWidget = () => {
  const sendGaEvent = (action, label) => {
    Event('training_resources', action, label)
  }
  const handleOpenCodeDialog = () => {
    sendGaEvent('show_code', 'show_code')
    BasicDialog({
      bodyRender: <><p><a
        target="_blank"
        rel={'noopener noreferrer'}
        className="discount-widget__link"
        onClick={() => sendGaEvent('open_link', 'all-courses')}
        href="https://academy.trainingthestreet.com/collections/all-courses?page=1"
      >Click Here</a> to purchase TTS courses.</p>
        <p>
          Use discount code <span className="discount-widget__link" style={{cursor: 'default', textDecoration: 'none'}}>GOBUYSIDE_25</span> at checkout
        </p>
      </>,
    });
  };

  return (
    <div className="discount-widget">
      <h3 className="discount-widget__title">
        Featured Training Resources
      </h3>
      <div className="discount-widget__row">
        <img src={"/img/logos/TrainingTheStreet_Stacked_PNG.png"} width={130} alt={"Training the Street"} title={"Training the Street"}/>
        <h4 className="discount-widget__subtitle" style={{display: "none"}}>
          Training the Street
        </h4>
        {/*<p className="discount-widget__content">*/}
        {/*  Leading finance training workshops and online courses, used by hundreds of banks and thousands of*/}
        {/*  professionals*/}
        {/*  each year.*/}
        {/*</p>*/}
        <p className="discount-widget__content">
          Discounted for GoBuyside members
          {' '}
          <button
            type="button"
            className="discount-widget__link"
            onClick={handleOpenCodeDialog}
          >
            Click to view
          </button>
        </p>
        <div className="discount-widget__content">
          Featured courses:
          <ul className="discount-widget__list">
            <li>
              <a
                target="_blank"
                rel={'noopener noreferrer'}
                className="discount-widget__link"
                onClick={() => sendGaEvent('open_link', 'essentials-bundle')}
                href="https://academy.trainingthestreet.com/products/essentials-bundle"
              >
                Self Study Bundle
              </a> - 25% ($125) off
            </li>
            <li>
              <a
                target="_blank"
                rel={'noopener noreferrer'}
                className="discount-widget__link"
                onClick={() => sendGaEvent('open_link', 'lbo-modeling')}
                href="https://academy.trainingthestreet.com/products/lbo-modeling"
              >
                LBO Modeling
              </a> - 25% off
            </li>
          </ul>
        </div>
      </div>
      <div className="discount-widget__row">
        <img src={"/img/logos/WSO-logo.png"} width={130} alt={"Wall Street Oasis"} title={"Wall Street Oasis"}/>
        <h4 className="discount-widget__subtitle" style={{display: 'none'}}>
          Wall Street Oasis
        </h4>
        {/*<p className="discount-widget__content">*/}
        {/*  Large online finance communities, offering a discussion board, coaching, and online self-study courses and*/}
        {/*  training materials.*/}
        {/*</p>*/}
        <p className="discount-widget__content">
          Use the links below to receive your GoBuyside member discount on featured courses:
        </p>
        <ul className="discount-widget__list">
          <li>
            <a
              target="_blank"
              rel={'noopener noreferrer'}
              className="discount-widget__link"
              onClick={() => sendGaEvent('open_link', 'leveraged-buyout-lbo')}
              href="https://www.wallstreetoasis.com/courses/financial-modeling-certification/leveraged-buyout-lbo/?affiliate=GoBuyside"
            >
              LBO Modeling Course
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel={'noopener noreferrer'}
              className="discount-widget__link"
              onClick={() => sendGaEvent('open_link', 'private-equity-deals-process')}
              href="https://www.wallstreetoasis.com/courses/financial-modeling-certification/private-equity-deals-process/?affiliate=GoBuyside"
            >
              PE Deals Process Course
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel={'noopener noreferrer'}
              className="discount-widget__link"
              onClick={() => sendGaEvent('open_link', 'elite-modeling-valuation-certification')}
              href="https://www.wallstreetoasis.com/courses/financial-modeling-prep/elite-modeling-valuation-certification/?affiliate=GoBuyside"
            >
              Elite Modeling Course
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DiscountWidget;
